theme.headerSticky = (function () {
  function ScrollSticky() {
    var headerStickyWrapper = document.querySelector("header");
    var headerStickyTargetList = document.querySelectorAll(".header__sticky");
    var headerSection = document.getElementById("shopify__header__section");
    var showOnScrollUp = headerSection && headerSection.dataset.stickyScrollUp === "true";

    if (headerStickyTargetList.length === 0) return;

    // Cache the header's initial offset once
    var headerOffset = 0;
    if (headerStickyWrapper) {
      headerOffset = headerStickyWrapper.offsetTop + headerStickyWrapper.offsetHeight;
    }

    var lastScrollY = window.scrollY;
    var scrollDelta = 0;
    var DELTA_THRESHOLD = 5; // Minimum scroll distance before toggling (prevents jitter)
    var isHidden = false;
    var rafId = null;

    function update() {
      rafId = null;
      var currentScrollY = window.scrollY;
      var delta = currentScrollY - lastScrollY;

      headerStickyTargetList.forEach(function (target) {
        if (currentScrollY > headerOffset) {
          target.classList.add("sticky");

          if (showOnScrollUp) {
            scrollDelta += delta;

            // Only toggle after exceeding threshold to prevent jitter
            if (scrollDelta < -DELTA_THRESHOLD && isHidden) {
              // Scrolled UP past threshold — show
              target.classList.remove("sticky--hidden");
              isHidden = false;
              scrollDelta = 0;
            } else if (scrollDelta > DELTA_THRESHOLD && !isHidden) {
              // Scrolled DOWN past threshold — hide
              target.classList.add("sticky--hidden");
              isHidden = true;
              scrollDelta = 0;
            }

            // Reset delta accumulator if direction changes
            if ((delta > 0 && scrollDelta < 0) || (delta < 0 && scrollDelta > 0)) {
              scrollDelta = delta;
            }
          }
        } else {
          // At top of page — always show, reset state
          target.classList.remove("sticky");
          target.classList.remove("sticky--hidden");
          isHidden = false;
          scrollDelta = 0;
        }
      });

      lastScrollY = currentScrollY;
    }

    window.addEventListener("scroll", function () {
      if (!rafId) {
        rafId = requestAnimationFrame(update);
      }
    }, { passive: true });
  }

  return ScrollSticky;
})();
